export default __webpack_public_path__ + "static/media/uruguay_flag.1ec7e3e6.svg";